import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class BreadCrumbs extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired
  }

  render() {
    return (
      <div className="breadcrumbs">
        {this.props.data.map((item, idx) => (
          <React.Fragment key={idx}>
            <Link to={item.url}>
              {item.text}
            </Link>
            {idx != this.props.data.length - 1 && <React.Fragment> &bull; </React.Fragment>}
          </React.Fragment>
        ))}
      </div>
    );
  }
}
